export const USERS_API_URL = process.env.REACT_APP_USERS_API_URL;
export const DEVICE_INFO_API_URL = process.env.REACT_APP_DEVICE_INFO_API_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const WINGPRO_URL = process.env.REACT_APP_WINGPRO_URL;
export const INVENTORY_URL = process.env.REACT_APP_INVENTORY_URL;
export const DOMAIN = process.env.REACT_APP_DOMAIN;
